import React from 'react'

const LOCALE_LABELS = {
  el: 'Ελληνικά',
  en: 'English'
}

export default function LanguagePicker({ className = '' }) {
  const availableLocales = (Support.availableLocales || [Support.locale]).map(locale => (
    typeof locale === 'string' ? { key: locale } : locale
  ))

  function buildLocalePath(locale) {
    const availableLocaleKeys = availableLocales.map(availableLocale => availableLocale.key)
    const pathParts = window.location.pathname.split('/')

    if (availableLocaleKeys.includes(pathParts[1])) {
      pathParts[1] = locale
    } else {
      pathParts.splice(1, 0, locale)
    }

    return `${pathParts.join('/')}${window.location.search}${window.location.hash}`
  }

  function handleLocaleChange(event) {
    const nextLocale = event.target.value

    if (nextLocale !== Support.locale) {
      window.location.href = buildLocalePath(nextLocale)
    }
  }

  if (availableLocales.length < 2) {
    return null
  }

  return (
    <div className={`language-picker ${className}`}>
      <i className='fa-light fa-globe' />
      <select value={ Support.locale } onChange={ handleLocaleChange } aria-label='Language'>
        { availableLocales.map(locale => (
          <option key={ locale.key } value={ locale.key }>
            { locale.label || LOCALE_LABELS[locale.key] || locale.key.toUpperCase() }
          </option>
        )) }
      </select>
      <i className='fa-light fa-chevron-down' />
    </div>
  )
}
